import React, { useState, useEffect } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

interface ConnectionFlowModalProps {
  isOpen: boolean;
  platformName: string;
  onClose: () => void;
  initiateAuth: () => Promise<void>;
}

export function ConnectionFlowModal({ isOpen, platformName, onClose, initiateAuth }: ConnectionFlowModalProps) {
  const [status, setStatus] = useState<'idle' | 'loading' | 'error'>('idle');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (isOpen) {
      setStatus('loading');
      initiateAuth().catch(err => {
        setErrorMessage(err.message || 'An unknown error occurred.');
        setStatus('error');
      });
    }
  }, [isOpen, initiateAuth]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4">
        <h2 className="text-xl font-bold mb-4">Connecting to {platformName}</h2>
        {status === 'loading' && (
          <div className="flex flex-col items-center">
            <Loader2 className="h-8 w-8 animate-spin text-blue-600" />
            <p className="mt-4 text-gray-600">Please complete the authorization in the popup window.</p>
          </div>
        )}
        {status === 'error' && (
          <div className="flex flex-col items-center">
            <AlertCircle className="h-8 w-8 text-red-600" />
            <p className="mt-4 text-red-700 font-semibold">Connection Failed</p>
            <p className="mt-2 text-gray-600 text-center">{errorMessage}</p>
            <button
              onClick={onClose}
              className="mt-4 px-4 py-2 rounded text-white bg-gray-500 hover:bg-gray-600"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
